<h2 mat-dialog-title>
  {{ isAddParticipant ? ('CHAT.ADD_PARTICIPANT' | translate) : ('CHAT.NEW_CONVERSATION' | translate) }}
</h2>

<div mat-dialog-content class="new-conversation-dialog">
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <ng-container *ngIf="!loading">
    <div class="new-conversation-dialog__empty" *ngIf="profils.length === 0">
      {{ 'CHAT.NO_ACTIVE_EMPLOYEES' | translate }}
    </div>

    <ng-container *ngIf="profils.length > 0">
      <mat-button-toggle-group *ngIf="!isAddParticipant" [(ngModel)]="mode" class="new-conversation-dialog__mode">
        <mat-button-toggle value="direct" class="new-conversation-dialog__mode-option">{{ 'CHAT.MODE_DIRECT' | translate }}</mat-button-toggle>
        <mat-button-toggle value="group" class="new-conversation-dialog__mode-option">{{ 'CHAT.MODE_GROUP' | translate }}</mat-button-toggle>
      </mat-button-toggle-group>

      <mat-form-field appearance="outline" *ngIf="isAddParticipant || mode === 'direct'" class="new-conversation-dialog__field">
        <mat-label>{{ 'CHAT.PICK_EMPLOYEE' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedProfilId">
          <mat-option *ngFor="let p of profils" [value]="p.id">{{ p.imie }} {{ p.nazwisko }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox *ngIf="isAddParticipant" [(ngModel)]="showFullHistory" class="new-conversation-dialog__checkbox">
        {{ 'CHAT.SHOW_FULL_HISTORY' | translate }}
      </mat-checkbox>

      <ng-container *ngIf="!isAddParticipant && mode === 'group'">
        <mat-form-field appearance="outline" class="new-conversation-dialog__field">
          <mat-label>{{ 'CHAT.GROUP_NAME' | translate }}</mat-label>
          <input matInput [(ngModel)]="groupName" maxlength="150" required>
        </mat-form-field>

        <mat-form-field appearance="outline" class="new-conversation-dialog__field">
          <mat-label>{{ 'CHAT.PICK_MEMBERS' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedGroupProfilIds" multiple>
            <mat-option *ngFor="let p of profils" [value]="p.id">{{ p.imie }} {{ p.nazwisko }}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="!canConfirm" (click)="confirm()">
    {{ 'COMMON.CONFIRM' | translate }}
  </button>
</div>
